import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

const Landing = ({ history }) => {
  history.replace('/career-explorer/about-you')
  return <></>
}

Landing.propTypes = {
  history: PropTypes.object.isRequired
}

export default withRouter(Landing)
